import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';

interface Props {
    count: number;
    maxCount: number;
}

function CircleProgress({ count, maxCount }:Props) {
    const percent = (count / maxCount) * 100;
    return (
        <Container>
            <BackGround percent={percent}/>
            <Contents>
                <Row spacing={4}>
                    <Text color={colors.gray9}
                        size='2xl'
                        fontWeight='bold'>
                        {count}
                    </Text>
                    <Text size='lg'>/{maxCount}</Text>
                </Row>
            </Contents>
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    display: flex;
    height: 104px;
    justify-content: center;
    position: relative;
    width: 104px;
`;

const BackGround = styled.div<{
    percent: number;
}>`
    border-radius: 52px;
    height: 104px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 104px;
    background: ${({ percent }) => (percent === 0
        ? 'var(--color-gray2)'
        : `conic-gradient(var(--color-primary) 0% ${percent}%, var(--color-gray2) ${percent}% 100%)`)};

    &::after {
        background-color: white;
        border-radius: 72px;
        content: '';
        height: 72px;
        position: absolute;
        width: 72px;
    }
`;

const Contents = styled.div`
    position: absolute;
`;

export default CircleProgress;
